export const SERVICES_IDS = {
  ADS: 1,
  ADS_FULL: 2,
  AI_AGENTS: 3,
  VPS_N8N: 4,
  EMAIL: 5,
};
